// extracted by mini-css-extract-plugin
export var animationContainer = "_mr-0";
export var footer = "_mr-1";
export var gray = "_mr-2";
export var lineItem = "_mr-3";
export var lineItemImage = "_mr-4";
export var lineItemInfo = "_mr-5";
export var lineItemText = "_mr-6";
export var lineItems = "_mr-7";
export var modalContent = "_mr-8";
export var options = "_mr-9";
export var orderName = "_mr-a";
export var refundAmount = "_mr-b";